import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { useGetMessagesQuery } from './messageApiSlice'
import { memo } from 'react'
import useAuth from "../../hooks/useAuth"
import TimeLeft from '../../partial/TimeLeft'
import ReactQuill from 'react-quill';

const Message = ({ messageId }) => {
    const {groupId, type} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()




    const { message } = useGetMessagesQuery("messagesList", {
        selectFromResult: ({ data }) => ({
            message: data?.entities[messageId]
        }),
    })

    const navigate = useNavigate()
  

    if (message) {
        //const created = new Date(message.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })
         const handleView = () => navigate(`/${type}/${groupId}/messages/${messageId}/actions`)
         const handleEdit = () => navigate(`/${type}/${groupId}/messages/${messageId}`)
         const cellStatus = message.active ? '' : 'table__cell--inactive'

         let editButton = null
         if(isAdmin|| isTeacher){editButton=(
             <button
             className="icon-button table__button"
             onClick={handleEdit}
         >
             <FontAwesomeIcon icon={faPenToSquare} />
         </button>
         )}
         
   
  
        return (
            <tr className="table__row">
                <td className={`table__cell message__title ${cellStatus}`}>{message.title}</td>
                  <td className={`table__cell message__title ${cellStatus}`}>{message.group.name}</td>
                  <td className={`table__cell message__dates ${cellStatus}`} > <TimeLeft endtime={message.toDate} /> </td>
                  <td className={`table__cell message__title ${cellStatus}`}>{message.specificUsers?"true":"false"}</td>
                  <td className={`table__cell message__title ${cellStatus}`}>{message.comments?.length}</td>


                <td className={`table__cell message__title ${cellStatus}`}>
                   
                   
                    {editButton}
               
                  
                </td>
            </tr>
        )

    } else return null
}

const memoizedMessage = memo(Message)

export default memoizedMessage